<template>
    <div class="modal is-active" v-if="show">
        <div class="modal-background" @click="cancel"></div>
        <div class="modal-card kb-prompt-modal">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ title }}</p>
                <button class="delete" @click.prevent="cancel"></button>
            </header>
            <section class="modal-card-body">
                <p v-if="message" class="kb-prompt-modal__message">{{ message }}</p>
                <input
                    v-if="kind === 'prompt'"
                    ref="input"
                    class="input"
                    type="text"
                    v-model="value"
                    :placeholder="placeholder"
                    @keydown.enter.prevent="submit"
                />
            </section>
            <footer class="modal-card-foot is-clearfix">
                <button
                    class="button"
                    :class="confirmClass"
                    :disabled="kind === 'prompt' && !value.trim()"
                    @click="submit"
                >
                    {{ submitText }}
                </button>
                <button class="button" @click="cancel">{{ cancelText || $t('generic.cancel') }}</button>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    name: 'kb-prompt-modal',

    data() {
        return {
            show: false,
            kind: 'prompt',
            title: '',
            message: '',
            placeholder: '',
            value: '',
            submitText: '',
            cancelText: '',
            danger: false,
            resolver: null,
        };
    },

    computed: {
        confirmClass() {
            return this.danger ? 'is-danger' : 'is-primary';
        },
    },

    methods: {
        prompt({title, message = '', placeholder = '', initial = '', submitText = null}) {
            return this._open({
                kind: 'prompt',
                title,
                message,
                placeholder,
                value: initial,
                submitText: submitText || this.$t('generic.save'),
                danger: false,
            });
        },
        confirm({title, message, submitText, danger = false}) {
            return this._open({
                kind: 'confirm',
                title,
                message,
                value: '',
                submitText,
                danger,
            });
        },
        _open(state) {
            Object.assign(this, state);
            this.show = true;
            this.$nextTick(() => {
                if(this.$refs.input) {
                    this.$refs.input.focus();
                    this.$refs.input.select();
                }
            });
            return new Promise(resolve => {
                this.resolver = resolve;
            });
        },
        submit() {
            if(this.kind === 'prompt' && !this.value.trim()) return;
            const result = this.kind === 'prompt' ? this.value.trim() : true;
            this.show = false;
            const r = this.resolver;
            this.resolver = null;
            r(result);
        },
        cancel() {
            this.show = false;
            const r = this.resolver;
            this.resolver = null;
            if(r) r(null);
        },
    },
};
</script>

<style lang="scss" scoped>
.kb-prompt-modal {
    max-width: 480px;
    margin: 0 auto;

    &__message {
        margin-bottom: 12px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/pages/knowledge-base/kb-prompt-modal.vue